import React from "react"
import { BackgroundShadow, StyledCardCategory } from "../styles"
import { CategoryAnchor, CategoryDescription, CategoryTitle, DetailContainer } from "./styles"

const Card = ({ title, category, triggerModal, numClasses }) => (
  <StyledCardCategory background={category.backgroundImage} onClick={triggerModal}>
    <BackgroundShadow />
    <DetailContainer>
      <CategoryTitle>{title}</CategoryTitle>
      <CategoryDescription>{`${numClasses} classes`}</CategoryDescription>
      <CategoryAnchor>View Classes</CategoryAnchor>
    </DetailContainer>
  </StyledCardCategory>
)

export default Card
